import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import icons from "../icons";
import { useForm } from "react-hook-form";
import { Link } from 'react-router-dom';
import { forgotPassword } from "../services/authApiRoutes/APImethods";
import { useState } from "react";
import { useRef } from "react";

export default function ForgotPassword() {
  const [status, setStatus] = useState(false);
  useEffect(() => {
    document.title = "OPAL-Marketing | The Marketing Globalization Platform - Forgot Password";
    backRef.current.focus()
  }, []);
  const navigate = useNavigate();

  const backRef = useRef(null)
  const returnRef = useRef(null);
  const navigateToLogin = () => {
    setStatus(false)
    navigate("/")
  };
  const { register, handleSubmit, setError, formState: { errors } } = useForm({ mode: "onSubmit" });
  const onFormSubmit = (data) => {
    forgotPassword(data).then(res => {
      if(res.data.status==='success'){
        setStatus(true)
        setTimeout(() => {
          returnRef.current.focus();
        }, 300);
      }else if(res.data.status==='failure'){
        setError('email', { type: 'custom', message: res.data.message });
      }
    }).catch(errors => {
    })
  }

  const handleError = (errors) => { };

  const validationRules = {
    email: {
      required: "Email is required",
      pattern: {
        value: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        message: "Email Format invalid"
      }
    }
  };

  return (
    <div className="wrapper">
      <div className="sign-page">
        <div className="content">
          <div className="back">
            <button ref={backRef} onClick={navigateToLogin}>
              <i aria-hidden="true"></i>Back
            </button>
          </div>
          <div className="small-container">
            <div className="logo-block">
              <Link to="/">
                <img src={icons.OPAL_LOGO} alt="OPAL-Marketing  logo" title="OPAL-Marketing logo" />
              </Link>
            </div>
            <div className={!status?"inner-content-wrap ":"inner-content-wrap hide"}>
              <h1>Forgot your password?</h1>
               <p>
                Enter the email address you used when you joined and we’ll send
                you instructions to reset your password.
              </p>

              <div className="image-block">
                <img src={icons.PASSWORD} alt="Password Icon" />
              </div>
               <form onSubmit={handleSubmit(onFormSubmit, handleError)}>
                <div className="wrap-form">
                  <div className="mar-bot30">
                  <div className="input-group mar-bot10">
                    <span className="input-group-text">
                      <img
                        src={icons.EMAIL_ICON}
                        alt="Email Icon"
                        title="Email Icon"
                      />
                    </span>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      name="email"
                      aria-describedby="emailError"
                      {...register('email', validationRules.email)}
                    />
                  </div>
                    <p className="error align-left mar-bot20" id="emailError">
                      <span dangerouslySetInnerHTML={{ __html: errors?.email && errors.email.message}}></span>
                    </p>
                  </div>
                  <div className="form-button">
                    <button type="submit" className="btn">
                      Send reset instructions
                    </button>
                  </div>
                </div>
              </form> 
            </div>

            <div className={!status?"inner-content-wrap email-send-block hide":"inner-content-wrap email-send-block"}>
              <h1>Mail Sent!</h1>
              <p>
                A mail with instructions to reset your password has been sent to
                the given email address. Please check your mail.
              </p>
              <div className="image-block">
                <img src={icons.MAIL_ICON} alt="Password Icon" />
              </div>
              <div className="wrap-form">
                <div className="form-button">
                  <button onClick={navigateToLogin} type="button" className="btn" ref={returnRef}>
                    Return to login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
